import './tag.scss';

import { kebabCase } from 'lodash';
import { useMemo } from 'react';

import {
  HealthProfessionalStatus,
  PatientStatus,
} from '../../data/types/api/graphql';
import { CustomFormattedMessage } from '../intl/custom-formatted-message';

export enum TagType {
  DEFAULT = 'default',

  // ACTIVATED = 'activated',
  // NOTACTIVATED = 'not-activated',
  ACTIVE = 'active',
  NOTACTIVE = 'not-active',
  NOAPP = 'no-app',

  NOINSURANCE = 'no-insurance',
  NOSHOWPROTOCOL = 'no-show-protocol',
  EMAILSENT = 'email-sent',
  EMAILNOTSENT = 'email-not-sent',
  ADMIN = 'admin',
  ORANGE = 'orange',
  TOOLTIP = 'tooltip',
  TOOLTIPERROR = 'tooltip-error',
  PORTAL = 'portal',
  SERVER = 'server',
  APP = 'app',
}

type TagProps = {
  type?: TagType | PatientStatus | HealthProfessionalStatus;
  text?: JSX.Element | string;
};

export function Tag({ ...props }: TagProps) {
  const { type, text } = useMemo(
    () => ({
      type: props.type,
      text: props?.text ?? (
        <CustomFormattedMessage id={`common.${kebabCase(props.type)}`} />
      ),
    }),
    [props.type, props.text]
  );

  return <span className={`tag tag--${type?.toLowerCase()}`}>{text}</span>;
}
